const getInitialState = () => ({
    viewedIntro: false,
    instructions: {
        words: '',
        voice: ''
    },
    rounds: [{ steps: [{ answer: '' }] }],
    progress: {
        roundIndex: -1,
        stepIndex: -1,
        completedSteps: []
    },
    data: {
        keyboard: {},
        activityId: '',
        rounds: {},
        showVideo: false,
        title: '',
        videos: [],
        type: '',
        category: '',
    },
    isRestarting: false,
    showIntro: true,
    dataLoaded: false,
    readyToStart: false,
    showAssessmentHelpBtn: false,
    keepInstructionsOnScreen: false,
    teacherAssist: undefined,
    teacherAction: undefined,
    spotCheckRetries: 0
});
export default getInitialState;
